module.exports = __webpack_public_path__ + "img/sign-44.6294ff27.jpg";